import { Avatar } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { BsArrowLeft } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import { postResetPassword } from "../redux/features/LoginSlice";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("resetToken");
  const isLoading = useSelector((state) => state.login.isLoading);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <div className="min-h-[calc(100vh)] flex items-center justify-center bg-gray-100 bg-register_bg bg-no-repeat bg-cover">
      <div className="p-6 bg-opacity-15 backdrop-blur-[1] bg-white shadow-lg rounded-xl md:w-[25rem] w-[90%]">
        <div className="flex flex-col gap-2 justify-center items-center">
          <Avatar sx={{ width: 100, height: 100 }} />
          <h2 className="text-xl font-medium text-white">Reset Password</h2>
        </div>
        <Formik
          initialValues={{ password: "", confirmPassword: "" }}
          validationSchema={Yup.object({
            password: Yup.string().required("Required"),
            confirmPassword: Yup.string()
              .oneOf([Yup.ref("password"), null], "Passwords must match")
              .required("Required"),
          })}
          onSubmit={(values) => {
            dispatch(
              postResetPassword({
                data: {
                  newPassword: values.password,
                  token,
                },
                navigate,
              })
            );
          }}
        >
          <Form className="space-y-7 mt-5">
            <div className="relative">
              <h2 className="text-base text-white">New Password</h2>
              <Field
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                autoComplete="new-password"
                placeholder="Enter new password"
                className="py-3 px-3 rounded-md border border-gray-300 w-full hover:border-black duration-200"
              />
              <span
                className="absolute right-3 top-11 cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
              </span>
              <ErrorMessage
                name="password"
                component="div"
                className="text-red-500 text-sm"
              />
            </div>
            <div className="relative">
              <h2 className="text-base text-white">Confirm Password</h2>
              <Field
                id="confirmPassword"
                name="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                autoComplete="new-password"
                placeholder="Confirm new password"
                className="py-3 px-3 rounded-md border border-gray-300 w-full hover:border-black duration-200"
              />
              <span
                className="absolute right-3 top-11 cursor-pointer"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? (
                  <AiOutlineEyeInvisible />
                ) : (
                  <AiOutlineEye />
                )}
              </span>
              <ErrorMessage
                name="confirmPassword"
                component="div"
                className="text-red-500 text-sm"
              />
            </div>
            <button
              type="submit"
              className="w-full flex justify-center hover:bg-white hover:border-black hover:text-black duration-500 rounded-full py-3 px-4 border border-transparent text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
              disabled={isLoading}
            >
              {isLoading ? "Resetting..." : "Reset Password"}
            </button>
          </Form>
        </Formik>

        <div className="text-sm text-center mt-4">
          <Link
            to="/login"
            className="flex items-center gap-2 font-medium text-white"
          >
            <BsArrowLeft /> Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
